import Vue from 'vue'
import Router from 'vue-router'

import Login from '../pages/login.vue'
import LoginNew from '../pages/loginNew.vue'
import Regist from '../pages/regist.vue'
import ResetWord from '../pages/resetWord.vue'

import PlatformLogin from '../pages/platformlogin.vue'

import Agreement from '../view/agreement.vue'
import index from '@/view/home/index.vue'
// import index from "@/view/index.vue"
// import About from "@/view/aboutus/index.vue"
import search from "../view/search.vue"
import searchItem from "../view/searchItem.vue"
import searchold from "../view/search3.vue"
import Uc from "../view/uc/index.vue"
import Intr from "../view/intrInfo/index.vue"
import ProductInfo from "../view/intrInfo/productInfo.vue"
import BookDetail from "../view/bookDetail/index.vue"
import bookList from "../view/bookList/index.vue"
import Books from "../view/books/index.vue"
import GoBooks from "../view/gobooks/index.vue"
import messageDetail from "../view/messageDetail.vue"
import viewer from "../view/viewer.vue"
import PageViewer from "../view/pageViewer"
// import EchartGx from "@/components/echart-gx.vue"
import Buy from "../view/buy.vue"
import Products from "../view/products/index.vue"
import Introduce from "../view/introduce/index.vue"
// import search from '../view/search.vue'
// import Uc from '../view/uc/index.vue'
// import Intr from '../view/intrInfo/index.vue'
// import ProductInfo from '../view/intrInfo/productInfo.vue'
// import BookDetail from '../view/bookDetail/index.vue'
// import messageDetail from '../view/messageDetail.vue'
// import viewer from '../view/viewer.vue'
// import PageViewer from '../view/pageViewer'
// import EchartGx from '@/components/echart-gx.vue'
// import Buy from '../view/buy.vue'
// import Products from '../view/products/index.vue'
// import Test from "../view/test/index.vue"
import Read from '../view/read/index.vue'
import eventBus from '@/utils/eventBus.js'
import pageViewer from '../view/pageViewer'

// import {
//   getInfo,
//   wxLogin
// } from "@/api/api"

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: index
    },
    // {
    //   path: '/echartgx',
    //   name: 'EchartGx',
    //   component: EchartGx
    // },
    {
      path: '/about',
      name: 'About',
      // component: About
      component: () => import('@/view/aboutus')
    },
    {
      path: '/messageDetail',
      name: 'messageDetail',
      component: messageDetail
    },

    {
      path: '/intr',
      name: 'intr',
      component: Intr
    },
    {
      path: '/productInfo',
      name: 'productInfo',
      component: ProductInfo
    },

    {
      path: '/search',
      name: 'Search',
      component: search,
      meta: {
        keepAlive: true
      },
      props: true
    },
    {
      path: '/searchItem',
      name: 'searchItem',
      component: searchItem,
      meta: {
        keepAlive: true
      },
      props: true
    },
    {
      path: '/searchold',
      name: 'Searchold',
      component: searchold,
      meta: {
        keepAlive: true
      },
      props: true
    },
    {
      path: '/viewer',
      name: 'viewer',
      component: viewer
    },
    {
      path: '/pageViewer',
      name: 'PageViewer',
      component: pageViewer
    },
    {
      path: '/bookDetail',
      name: 'bookDetail',
      component: BookDetail
    },
    {
      path: '/uc',
      name: 'Uc',
      component: Uc
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/regist',
      name: 'Regist',
      component: Regist
    },
    {
      path: '/resetWord',
      name: 'ResetWord',
      component: ResetWord
    },
    {
      path: '/loginNew',
      name: 'LoginNew',
      component: LoginNew
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: Agreement
    },
    {
      path: '/platelogin',
      name: 'platformLogin',
      component: PlatformLogin
    },
    {
      path: '/buy',
      name: 'Buy',
      component: Buy
    },
    {
      path: '/products',
      name: 'Products',
      component: Products
    },
    {
      path: "/introduce/:articleType",
      name: "Introduce",
      component: Introduce,
      props: true
    },
    {
      path: '/read',
      name: 'Read',
      component: Read,
    },
    {
      path: '/booklist',
      name: 'bookList',
      component: bookList
    },
    {
      path: '/books',
      name: 'Books',
      component: Books,
      props: true
    },
    {
      path: '/gobooks',
      name: 'GoBooks',
      component: GoBooks,
      props: true
    }
    // {
    //   path: "/test",
    //   name: "Test",
    //   component: Test
    // },
  ]
})

router.beforeEach((to, from, next) => {
  // if (localStorage.token) {
  //   eventBus.$emit("openBindMobile")
  // }
  // 一小时更新
  let userinfo = localStorage.userinfo ? JSON.parse(localStorage.userinfo) : {}
  if (localStorage.token) {
    // console.log(new Date().getTime(), 'new Date().getTime()')
    let EXPIRESTIME = 86400000
    // let EXPIRESTIME = 1
    let start = localStorage.starttime

    if (start) {
      let endtime = new Date().getTime()
      if (endtime - start > EXPIRESTIME) {
        eventBus.$emit('busGetMaps')
      }
    } else {
      eventBus.$emit('busGetMaps')
    }
    // 绑定手机号
    if (JSON.stringify(userinfo) != '{}' && (!userinfo.mobile || userinfo.mobile == '')) {
      eventBus.$emit('openBindMobile')
    }
  }
  if (to.query.code) {
    let code = to.query.code
    // eventBus.$emit('WeiLogin', code)
    console.log('eee')
    eventBus.$emit('dkLogin', code)

  } else {
    next()
  }
})
router.afterEach((to, from) => {
  // console.log(to.name, 'to.name')
  eventBus.$emit('addLatestNew')
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js